import { render, staticRenderFns } from "./VDaterange.vue?vue&type=template&id=6a453b5a&scoped=true&"
import script from "./VDaterange.vue?vue&type=script&lang=js&"
export * from "./VDaterange.vue?vue&type=script&lang=js&"
import style0 from "./VDaterange.vue?vue&type=style&index=0&id=6a453b5a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a453b5a",
  null
  
)

export default component.exports